import { render } from "./calendar.vue?vue&type=template&id=53991e4e&ts=true"
import script from "./calendar.vue?vue&type=script&lang=ts"
export * from "./calendar.vue?vue&type=script&lang=ts"

import "./calendar.vue?vue&type=style&index=0&id=53991e4e&lang=less"

import exportComponent from "C:\\code\\webapp\\postcard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__